<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش الفبا</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/dictation/alphabet/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت الفبای جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                item-key="id"
                show-expand
                :headers="headers"
                :items="alphabets.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/dictation/alphabet/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.cover`]="{ item }">
                <img :src="item.cover" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.audio`]="{ item }">
                <audio :src="item.audio" controls />
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="alphabets.current_page"
                :length="alphabets.last_page"
                circle
                @input="getAlphabets"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این الفبا اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AlphabetDictationIndex",
  data() {
    return {
      loading: true,
      alphabets: {
        current_page: 1
      },
      selectedEntityId: null,
      deleteDialog: false,
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'label', align: 'center', width: '2%'},
        {text: 'نوع', value: 'type', align: 'center', width: '10%'},
        {text: 'کاور', value: 'cover', align: 'center', width: '10%'},
        {text: 'توضیحات', value: 'description', align: 'center', width: '5%'},
        {text: 'فایل صوتی', value: 'audio', align: 'center', width: '3%'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '15%'},
      ],
    }
  },
  mounted() {
    this.getAlphabets()
  },
  methods:{
    getAlphabets() {
      let url = '/course/dictation/alphabet/index?page=' + this.alphabets.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.alphabets = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    finalDestroy() {
      window.axios.delete('course/dictation/alphabet/delete/' + this.selectedEntityId).then(() => {
        this.getAlphabets()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    destroy(courseId) {
      this.selectedEntityId = courseId
      this.deleteDialog = true
    }
  }
}
</script>


<style scoped>

</style>